import { ModelSagres } from "@/types/model-sagres";
import { Municipio } from "../municipio";
import { Anexo } from "./anexo-novo-usuario";

export class NovoUsuario extends ModelSagres {
  BAIRRO: string;
  CEP: string;
  CODIGO_ATIVACAO: string;
  COMPLEMENTO: string;
  CPF: string;
  DATA_CRIACAO: Date;
  DATA_ULT_ALTERACAO: Date;
  EMAIL: string;
  FL_COMUNICA_TELEFONE: boolean;
  ID_MUNICIPIO: string;
  ID_NOVO_USUARIO: number;
  LIMITE_ATIVACAO: Date;
  LOGRADOURO: string;
  NOME: string;
  NUMERO: string;
  OAB: string;
  SITUACAO: string;
  TELEFONE: string;
  USUARIO_ULT_ALTERACAO: string;
  CRP_MUNICIPIO?: Municipio;
  ANEXO?: Anexo[];
  SENHA: string;

  doc_foto?: any;
  doc_foto_verso?: any;
  comp_residencia?: any;

  constructor(obj?: any) {
    super();
    //console.log(obj)
    if (obj) {
      if (obj.BAIRRO) this.BAIRRO = obj.BAIRRO;
      if (obj.CEP) this.CEP = obj.CEP;
      if (obj.CODIGO_ATIVACAO) this.CODIGO_ATIVACAO = obj.CODIGO_ATIVACAO;
      if (obj.COMPLEMENTO) this.COMPLEMENTO = obj.COMPLEMENTO;
      if (obj.CPF) this.CPF = obj.CPF;
      if (obj.DATA_CRIACAO) this.DATA_CRIACAO = new Date(obj.DATA_CRIACAO);
      if (obj.DATA_ULT_ALTERACAO)
        this.DATA_ULT_ALTERACAO = new Date(obj.DATA_ULT_ALTERACAO);
      if (obj.EMAIL) this.EMAIL = obj.EMAIL;
      this.FL_COMUNICA_TELEFONE = obj.FL_COMUNICA_TELEFONE;
      if (obj.ID_MUNICIPIO) this.ID_MUNICIPIO = obj.ID_MUNICIPIO;
      if (obj.ID_NOVO_USUARIO) this.ID_NOVO_USUARIO = obj.ID_NOVO_USUARIO;
      if (obj.LIMITE_ATIVACAO)
        this.LIMITE_ATIVACAO = new Date(obj.LIMITE_ATIVACAO);
      if (obj.LOGRADOURO) this.LOGRADOURO = obj.LOGRADOURO;
      if (obj.NOME) this.NOME = obj.NOME;
      if (obj.NUMERO) this.NUMERO = obj.NUMERO;
      if (obj.OAB) this.OAB = obj.OAB;
      if (obj.SITUACAO) this.SITUACAO = obj.SITUACAO;
      if (obj.TELEFONE) this.TELEFONE = obj.TELEFONE;
      if (obj.USUARIO_ULT_ALTERACAO)
        this.USUARIO_ULT_ALTERACAO = obj.USUARIO_ULT_ALTERACAO;
      if (obj.CRP_MUNICIPIO)
        this.CRP_MUNICIPIO = new Municipio(obj.CRP_MUNICIPIO);
      if (obj.SENHA) this.SENHA = obj.SENHA;

      if (obj.ANEXO) {
        this.ANEXO = obj.ANEXO.map((anexo: any) => ({
          ID_ANEXO: anexo.ID_ANEXO,
          DATA_CRIACAO: new Date(anexo.DATA_CRIACAO),
          USUARIO_ULT_ALTERACAO: anexo.USUARIO_ULT_ALTERACAO,
          NOME_ANEXO: anexo.NOME,
          FILEPATH: anexo.FILEPATH,
          TAMANHO: anexo.TAMANHO,
          TIPO: anexo.TIPO,
          ID_NOVO_USUARIO: anexo.ID_NOVO_USUARIO,
        }));

        const arqCpf = this.ANEXO?.find((x) => x.TIPO === "cpf");
        const arqCpfVerso = this.ANEXO?.find((x) => x.TIPO === "cpfverso");
        const arqResidencia = this.ANEXO?.find((x) => x.TIPO === "residencia");
        if (arqCpf !== undefined)
          this.doc_foto = Object.assign(new Anexo(), arqCpf);
        if (arqCpfVerso !== undefined)
          this.doc_foto_verso = Object.assign(new Anexo(), arqCpfVerso);
        if (arqResidencia !== undefined)
          this.comp_residencia = Object.assign(new Anexo(), arqResidencia);
      }
    }
  }

  getTipoArquivo(tipo: string) {
    if (tipo === "cpf") {
      if (this.doc_foto instanceof File) return "naosalvo";
      if (this.doc_foto instanceof Anexo) return "salvo";
    } else if (tipo === "cpf_verso") {
      if (this.doc_foto_verso instanceof File) return "naosalvo";
      if (this.doc_foto_verso instanceof Anexo) return "salvo";
    } else if (tipo === "residencia") {
      if (this.comp_residencia instanceof File) return "naosalvo";
      if (this.comp_residencia instanceof Anexo) return "salvo";
    }
    return null;
  }

  toUsuarioCertificado(): any {
    return {
      NM_TELEFONE: this.TELEFONE || "",
      NM_LOGRADOURO: this.LOGRADOURO || "",
      NU_NUMERO: this.NUMERO || "",
      NM_CEP: this.CEP || "",
      NM_COMPLEMENTO: this.COMPLEMENTO || "",
      NM_BAIRRO: this.BAIRRO || "",
      ID_CRP_MUNICIPIO: this.ID_MUNICIPIO || "0",
      NM_PASSWORD: this.SENHA || "",
      FL_COMUNICA_TELEFONE:
        this.FL_COMUNICA_TELEFONE !== undefined
          ? this.FL_COMUNICA_TELEFONE
            ? "true"
            : "false"
          : undefined,
    };
  }
}
